$(document).ready(function () {
  
  var selectedVariantId = localStorage.getItem("selectedVariantId");
  $(".product-single__variants option").each(function () {
    var option_id = $(this).val();
    if (selectedVariantId == option_id) {
      $('.product-variant-id').val(selectedVariantId);
    }
  });

  if ($("body").hasClass("temp_product-buymore")) {
      var selectedVariantId = localStorage.getItem("selectedVariantId");
      $('.product-variant-id').val(selectedVariantId);
    
      $('[name="subscribe-rb"]:checked').parents('.subscribe_onetime_common').find('.qty_frequency_main').show();
   
    $('[name="subscribe-rb"]').on('change', function(){
      $('.qty_frequency_main').hide();
      $('[name="subscribe-rb"]:checked').parents('.subscribe_onetime_common').find('.qty_frequency_main').show();
    });
    var qts_y_load = $('.active-pair').data("qty");
    $(".cstm_qty_main").val(qts_y_load);
    $(document).on("click", ".pair2", function (evt) {
      $(".pair2").removeClass("active-pair");
      $(this).addClass("active-pair");
      var qts_y = $(this).data("qty");
      $(".cstm_qty_main").val(qts_y);
    });
    $(".product-form__input").on("change", function () {
      setTimeout(function () {
        var var_id = $(".product-variant-id").val();
        $(".product-single__variants option").each(function () {
          var option_id = $(this).val();
          if (var_id == option_id) {
            $(this).attr("selected", true).change();
          } else {
            $(this).attr("selected", false).change();
          }
        });
      }, 500);
    });
    $(document).on("click", ".product-form__submit", function (e) {
      e.preventDefault();
      if ($(".cstm_size input:checked").val() != undefined) {
        $(".product-form__error-message-wrapper").hide();
        var checked_input = $('[name="subscribe-rb"]:checked').val();
        if (checked_input == "subscribe") {
          var qty = $(".cstm_qty_subscribe .quantity__input").val();
          var subsId = $(
            "select.product-single__variants.no-js option:selected"
          ).data("subsid");
          var freq = $("#subs-delevry").val();
          addItemToCart(subsId, qty, freq, "Months");
        } else {
          $("form.form").submit();
        }
      } else {
        $(".product-form__error-message-wrapper")
          .text("Please select size!")
          .show();
      }
    });
  }

  function addItemToCart(variant_id, qty, frequency, unit_type) {
    data = {
      id: variant_id,
      quantity: qty,
      properties: {
        shipping_interval_frequency: frequency,
        shipping_interval_unit_type: unit_type,
      },
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        window.location.href = "/cart";
      },
    });
  }
});
  
  function checkContainer () {
    if ($('.totals .hulkapps-cart-total').is(':visible')) { 
      $('.totals .totals__total-value').addClass('line_through')
    } 
  }
  var interval = self.setInterval(function(){checkContainer()},500);
